'use client';

import { MapPin, Menu, Phone, X } from 'lucide-react';
import { useRef } from 'react';

import logo from '@/shared/assets/icons/logo.svg';
import Image from 'next/image';
import Link from 'next/link';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { PHONE_NUMBER, PHONE_NUMBER_LINK } from '@shared/constants/contacts';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { Container } from '@shared/ui/Container';
import { CustomLink } from '@shared/ui/CustomLink';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
// import { Socials } from '@shared/ui/Socials';
import { addPadding, removePadding } from '@shared/utils/scrollHelpers/scrollHelpers';
import { openCallModal } from '@widgets/CallModal';

import { toggleMobileMenu } from '../../model/slice/headerSlice';
import { Links } from './Links/Links';
import { MobileMenu } from './MobileMenu/MobileMenu';
import cls from './Top.module.scss';

export const Top = () => {
  const dispatch = useAppDispatch();
  const openMobileMenu = useAppSelector((state) => state.header.openMobileMenu);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const viewPort = useAppSelector(getViewPort);

  const toggleMenu = () => {
    if (openMobileMenu) {
      removePadding();
      dispatch(toggleMobileMenu(false));
    } else {
      addPadding();
      dispatch(toggleMobileMenu(true));
    }
  };

  const openCallModalHandler = () => {
    dispatch(openCallModal());
  };

  return (
    <div
      data-testid={'header-top'}
      className={cls.wrap}
    >
      <Container className={cls.container}>
        <div className={cls.col}>
          <Link
            aria-label={'Перейти на главную'}
            className={cls.logo}
            href={ROUTES.MAIN}
          >
            <Image
              src={logo}
              alt={'Логотип'}
              fill
            />
          </Link>
          <Links className={cls.links} />
        </div>
        <div className={cls.col}>
          <Button
            testId={'open-callModal-button'}
            size={'s'}
            onClick={openCallModalHandler}
            className={cls.call}
          >
            Перезвоните мне
          </Button>
          {/*<Socials className={cls.socials} />*/}
          <CustomLink
            href={ROUTES.MAIN}
            iconPosition={'left'}
            icon={<MapPin color={ICON_DEFAULT} />}
            className={cls.geo}
          >
            Н. Новгород
          </CustomLink>
          <CustomLink
            aria-label={`Позвонить на номер ${PHONE_NUMBER_LINK}`}
            href={`tel:${PHONE_NUMBER_LINK}`}
            iconPosition={'left'}
            icon={<Phone color={ICON_DEFAULT} />}
            className={cls.phone}
          >
            {PHONE_NUMBER}
          </CustomLink>
        </div>

        <button
          aria-label={openMobileMenu ? 'Закрыть меню' : 'Открыть меню'}
          ref={buttonRef}
          onClick={toggleMenu}
          className={cls.button}
          data-testid={'mobile-menu-button'}
        >
          {openMobileMenu ? <X /> : <Menu />}
        </button>

        {openMobileMenu && viewPort !== 'desktop' && <MobileMenu buttonRef={buttonRef} />}
      </Container>
    </div>
  );
};
